// extracted by mini-css-extract-plugin
export var container = "index-module--container--3JlRy";
export var background = "index-module--background--2pFx5";
export var textContent = "index-module--textContent--Cu1VD";